import * as windowsActions from '../actions/windows.actions';
import {Product} from '../models/Product';

export interface IWindowsState {
  windows: Product[];
  loading: boolean;
  lastLoadedTime: number;
}

export const inittialProductState: IWindowsState = {
  windows: [],
  loading: false,
  lastLoadedTime: new Date().getTime()
};

export function reducer(windowsState: IWindowsState = inittialProductState,
                        action: windowsActions.WindowAction): IWindowsState {

  switch (action.type) {

    case windowsActions.LOAD_WINDOWS: {
      return {
        ...windowsState,
        loading: true
      };
    }

    case windowsActions.FETCH_WINDOWS_FAILED: {
      return {
        ...windowsState,
        loading: false
      };
    }

    case windowsActions.LOAD_WINDOWS_SUCCESS : {
      return {
        windows : action.payload,
        loading: false,
        lastLoadedTime: new Date().getTime()
      };
    }

    default : {
      return windowsState;
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/reducers/window.reducer.ts